/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiWindowNewUpRightIcon20Solid = forwardRef('UiWindowNewUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.5 2A2.5 2.5 0 0 0 5 4.5v6A2.5 2.5 0 0 0 7.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 16.5 2h-9Z" }),
        React.createElement("path", { d: "M3.5 6H4v5a3 3 0 0 0 3 3h8v.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 14.5v-6A2.5 2.5 0 0 1 3.5 6Z" })));
});
